import cx from 'classnames';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../../../../types/redux';
import { TFeature } from '../../../../../types/map';
import { useMapContext } from '../../../context';
import * as styles from './DotActive.css';

interface IDotActiveProps {
  resultsAvailable: boolean;
  detailsVisible: boolean;
}

export const DotActive: React.FC<IDotActiveProps> = ({
  resultsAvailable: isResultsAvailable,
  detailsVisible: isDetailsVisible,
}) => {
  const { ymaps, map } = useMapContext();
  const selectedFeature = useSelector<IApplicationState, TFeature | null>(state => state.activeFeature);
  const isNewbuildingsListing = useSelector<IApplicationState, boolean>(state => state.isNewbuildingsListing);
  const iconLayout = React.useRef((isNewbuildingsListing: boolean, isSmall: boolean) =>
    ymaps.templateLayoutFactory.createClass(
      `<div class="${cx(styles['container'], {
        [styles['container--small']]: isSmall,
        [styles['container--blue']]: !isNewbuildingsListing,
        [styles['container--green']]: isNewbuildingsListing,
      })}">{% if properties.count > 1 %}{% if properties.count <= 9 %}{{properties.count}}{% else %}9+{% endif %}{% endif %}</div>`,
    ),
  );
  const placemarkObject = React.useRef<YMaps.GeoObject | null>(null);

  React.useEffect(() => {
    if (placemarkObject.current) {
      map.geoObjects.remove(placemarkObject.current);
      placemarkObject.current = null;
    }

    if (
      !isResultsAvailable ||
      (isDetailsVisible &&
        (!selectedFeature || !selectedFeature.properties.isExtended || selectedFeature.properties.specialPromo))
    ) {
      return;
    }

    if (selectedFeature) {
      const isSmallPlacemark = selectedFeature.properties.count === 1;

      placemarkObject.current = new ymaps.GeoObject(
        {
          ...selectedFeature,
          type: 'Feature',
          id: 'DotActiveFeature',
        },
        {
          iconLayout: iconLayout.current(isNewbuildingsListing, isSmallPlacemark),
        },
      );

      map.geoObjects.add(placemarkObject.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFeature]);

  React.useEffect(() => {
    if (!isResultsAvailable || isDetailsVisible) {
      if (placemarkObject.current) {
        map.geoObjects.remove(placemarkObject.current);
        placemarkObject.current = null;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResultsAvailable, isDetailsVisible]);

  return null;
};
